import React, { useEffect, useState } from "react";
import "./SecondaryFooter.css"; // Ensure correct styles are imported

const SecondaryFooter = () => {
    const [year, setYear] = useState(new Date().getFullYear());

    useEffect(() => {
        setYear(new Date().getFullYear());
    }, []);

    return (
        <div className="secondary-footer">
            <div className="secondary-footer-container">
                <p className="secondary-footer-copyright">
                    © Österreichische Nationalbibliothek <span>{year}</span>
                </p>
                <nav className="secondary-footer-links">
                    <a href="https://www.onb.ac.at/impressum">Impressum</a>
                    <a href="https://www.onb.ac.at/datenschutz">Datenschutz</a>
                    <a href="https://www.onb.ac.at/#fcc-reset-cookie">Cookie Einstellungen</a>
                    <a href="https://www.onb.ac.at/barrierefreiheitserklaerung">Barrierefreiheitserklärung</a>
                    <a href="https://www.onb.ac.at/nutzung">Nutzung</a>
                </nav>
            </div>
        </div>
    );
};

export default SecondaryFooter;
